import React from "react"
import Layout from "./hoc/Layout"
import ReactGA from "react-ga4"
import { ANALYTICS_ID, IS_PROD_ENV } from "./config"
import { initDatadog } from "./datadog"

import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import localizedFormat from 'dayjs/plugin/localizedFormat';

dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.extend(localizedFormat);

function App(props: any) {
	/* eslint eqeqeq: 0 */
	if (IS_PROD_ENV) {
		initDatadog()
		console.log("GA intialized")
		ReactGA.initialize(ANALYTICS_ID)
	}

	return (
		<div>
			<Layout {...props} />
		</div>
	)
}

export default App
